import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyCvktOOvzCgzMJhnbLs_jdcLTfJyXt43uo",
  authDomain: "singbarbershop-ce4d3.firebaseapp.com",
  projectId: "singbarbershop-ce4d3",
  storageBucket: "singbarbershop-ce4d3.firebasestorage.app",
  messagingSenderId: "651655952037",
  appId: "1:651655952037:web:d45f87e56810adb5103f4c",
  measurementId: "G-DNGLXVTGQG",
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);

export default db;
